import { render } from "./modalAttachedPointeuses.vue?vue&type=template&id=61ace4bf&ts=true"
import script from "./modalAttachedPointeuses.vue?vue&type=script&lang=ts"
export * from "./modalAttachedPointeuses.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__